import React from 'react';
import {
    UsagePriceFont,
    UsagePricingDataContainer,
} from './BundleCards.styled';
import { useTranslation } from 'react-i18next';

const SerialNoLabel = ({
    serialNo,
    flexDirection,
    showLabel,
    alignItemsContainer,
    justifyContentContiner,
    heightContainer,
    marginContainer,
    paddingContainer,
    wordBreak
}) => {
    const { t } = useTranslation();
    return (
        <>
            <UsagePricingDataContainer
                margin={marginContainer}
                flexDirection={flexDirection}
                alignItems={alignItemsContainer}
                justifyContent={justifyContentContiner}
                height={heightContainer}
                padding={paddingContainer}
                wordBreak={wordBreak}
            >
                {showLabel ? (
                    <UsagePriceFont
                        lineHeight="22px"
                        letterSpacing="-0.1px"
                        color="#140F4B"
                        fontFamily="AvenirNextWorld Demi"
                        textAlign='left'
                    >
                        {t(
                            'reportUsage.review.itemsToBeBilled.ItemsToBeBilled.lotSerial'
                        )}
                    </UsagePriceFont>
                ) : null}

                <UsagePriceFont
                    lineHeight="22px"
                    letterSpacing="-0.1px"
                    color="#140F4B"
                    padding="0rem 0rem 0rem 0.2rem"
                    textAlign='left'
                >
                    {serialNo ? serialNo : null}
                </UsagePriceFont>
            </UsagePricingDataContainer>
        </>
    );
};

export default SerialNoLabel;
